import React from "react";
import { createProject } from "../../../redux/ducks/project";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import { useState } from "react";
import TextInput from "../../dumb/TextInput";
import NumInput from "../../dumb/NumInput";

const AddProject = props => {
    const [show, hide, renderModal] = useModal();
    const [d_createProject, status, error, event] = useStatusThunk(createProject);

    const [projectName, setProjectName] = useState();
    const [orderNumber, setOrderNumber] = useState();

    event.onSuccess = () => {
        hide();
        setProjectName(null);
        setOrderNumber(null);
    }

    return (
        <React.Fragment>
            <button className={"button button--primary " + props.className} onClick={show}>Add PO</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <div className="label">Description</div>
                        <TextInput v={projectName} set={setProjectName} />
                    </div>

                    <div className="group">
                        <div className="label">PO #</div>
                        <NumInput v={orderNumber} set={setOrderNumber} />
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className="button--primary" progress="Working" onClick={() => { d_createProject({ projectName, titleID: props.titleID, orderNumber }) }}>Add PO</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default AddProject;